import { render, staticRenderFns } from "./digit2.vue?vue&type=template&id=15da0702&"
import script from "./digit2.vue?vue&type=script&lang=js&"
export * from "./digit2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports